import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { PORTRAIT } from "@/data/content";

const STATS = [
  { n: "15+", l: "års digital ledelse" },
  { n: "7", l: "brancheledende brands" },
  { n: "5+", l: "digitale transformationer" },
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], [-40, 60]);

  return (
    <section
      id="om"
      ref={ref}
      data-testid="about-section"
      className="bg-[#ffffff] text-[#141414] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-14 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
            Om Morten
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#f4f4f2]">
                <motion.img
                  src={PORTRAIT}
                  alt="Morten Junge Bertelsen"
                  style={{ y: imgY }}
                  className="photo-color absolute inset-0 h-[112%] w-full object-cover object-top -top-[6%]"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-[#141414]/10" />
              </div>
              <p className="mt-4 font-ui text-xs uppercase tracking-[0.2em] text-[#6f6f6a]">
                Morten Junge Bertelsen — Partner, ShopSEO
              </p>
            </Reveal>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-display font-light leading-[1.08] text-3xl sm:text-4xl md:text-5xl lg:text-[3.3rem] text-balance">
                Erfaren digital leder i krydsfeltet mellem{" "}
                <span className="italic text-[#1f3d2b]">strategi</span>,
                e-commerce og{" "}
                <span className="italic text-[#1f3d2b]">forretningsudvikling</span>{" "}
                — med dokumenterede resultater på både operationelt og strategisk
                niveau.
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <p className="mt-8 max-w-2xl font-ui text-base md:text-lg text-[#5a5a56] leading-relaxed">
                Som Chief Digital Officer, Head of Global E-commerce og
                International E-commerce Manager har jeg været drivkraften bag
                flere succesfulde digitale transformationer og relanceringer —
                herunder implementering af CMS, PIM, ERP og DAM samt udvikling af
                datadrevne beslutningsmodeller. Jeg arbejder analytisk og
                samarbejdsorienteret med at bygge skalerbare digitale setups, der
                skaber målbar vækst på tværs af kanaler.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#e4e4e1] pt-10">
              {STATS.map((s, i) => (
                <Reveal key={s.n} delay={0.1 + i * 0.1}>
                  <div>
                    <div className="font-display text-4xl md:text-6xl leading-none text-[#1f3d2b]">
                      {s.n}
                    </div>
                    <div className="mt-2 font-ui text-xs md:text-sm uppercase tracking-[0.14em] text-[#6f6f6a]">
                      {s.l}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
